module.exports = __webpack_public_path__ + "img/done-status.6ffa14f1.svg";